module.exports = __webpack_public_path__ + "static/img/tongguo1.a5f9b137.png";